import React from "react";
import { useNavigate } from "react-router-dom";
import CustomViewButton from "../../../CustomComponent/custom_view_button";
import { BsArrowRightShort } from "react-icons/bs";
import { useSelector } from "react-redux";

const tableHead = [
  "Sr.",
  "Farm Name",
  "Resource Name",
  "Vendor",
  "Amount",
  "Refill Frequency",
  "Actions",
];

const tableHeadClient = [
  "Sr.",
  "Resource Name",
  "Vendor",
  "Amount",
  "Refill Frequency",
  "Actions",
];

const InventoryTrackingTable = ({ EX = [], currentPage, itemsPerPage }) => {
  const navigate = useNavigate();
  const store = useSelector((store) => store.login.user);
  const goToView = (id) => {
    navigate(`/resources-inventory/view/${id}`);
  };

  return (
    <div className="table-responsive">
      <table className="table table-vcenter">
        <thead>
          <tr>
            {store.Role === process.env.REACT_APP_ROLE_CLIENT
              ? tableHeadClient?.map((item, index) => {
                  return <th key={index}>{item}</th>;
                })
              : tableHead?.map((item, index) => {
                  return <th key={index}>{item}</th>;
                })}
          </tr>
        </thead>
        <tbody>
          {EX?.map((item, index) => {
            const Index = (currentPage - 1) * itemsPerPage + index + 1;
            return (
              <tr key={item?.id}>
                <td>{Index}</td>
                {store.Role !== process.env.REACT_APP_ROLE_CLIENT && (
                  <td>{item?.farmName || "N/A"}</td>
                )}
                <td>{item?.assetName || "N/A"}</td>
                <td>{item?.vendor || "N/A"}</td>
                <td>{item?.paymentAmount || "N/A"}</td>
                <td>{item?.frequencyCycle || "N/A"}</td>
                <td>
                  <CustomViewButton
                    onClick={() => goToView(item.id)}
                  ></CustomViewButton>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default InventoryTrackingTable;
